import React from "react";
import PropTypes from "prop-types";

const DaajiMessage = ({ homeProp, eventInfo }) => {
  if (homeProp && eventInfo.length < 1) {
    return null;
  }

  const downloadPdf = (language) => {
    const link =
      eventInfo?.find((item) => item?.language === language)?.link || "#";
    const a = document.createElement("a");
    a.target = "_blank";
    a.href = link;
    a.click();
  };

  return (
    <div className="daaji_wrrapper">
      <div className="container">
        {eventInfo.length > 0 ? (
          <div className="daaji_box">
            <h2>
              <span>Daaji&apos;s Message</span>
            </h2>
            <p className="text-center">
              Daaji is releasing the celebration message before the event, so
              that we have the opportunity beforehand to reflect on how to lead
              a life in tune with the message being shared. It is available in
              many languages to download below.
            </p>
            <h6 className="mb-4">
              Choose your Language:
              <br />
            </h6>
            <div className="row">
              {eventInfo.map((item) => (
                <div className="col-sm-6 col-md-3">
                  <div
                    role="button"
                    tabIndex={0}
                    className="message-contents"
                    onClick={() => {
                      downloadPdf(item.language);
                    }}
                    onKeyDown={() => {
                      downloadPdf(item.language);
                    }}
                  >
                    {item.language}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-md-12">
              <h2>
                <span>Daaji&apos;s Message</span>
              </h2>
              <p>
                Daaji will release a message during the celebrations that will
                be available in many languages.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DaajiMessage.propTypes = {
  homeProp: PropTypes.bool,
  eventInfo: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      language: PropTypes.string,
    })
  ),
};

DaajiMessage.defaultProps = {
  homeProp: false,
  eventInfo: [],
};

export default DaajiMessage;
